import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <div className="mx-auto mt-12 flex w-full max-w-2xl flex-col items-center gap-4 rounded-2xl border border-teal/30 bg-ink-2 p-6 text-center sm:flex-row sm:items-start sm:text-left" style={{
    paddingTop: "8px",
    paddingBottom: "7px"
  }} data-id="element-99" data-mp="1o3x3nprb6w3l">
      
      <div data-id="element-100" data-mp="1x4uz3jnolvak">
        <h3 className="font-display text-xl font-bold uppercase text-fog" data-id="element-101" data-mp="1x54p378q82g9">Your 7-Day Money-Back Guarantee</h3>
        <p className="mt-0.5 text-sm font-semibold text-teal" data-id="element-102" data-mp="19co9d3cgomk4">Try the system with confidence</p>
        <p className="mt-3 text-[15px] leading-relaxed text-fog/75" data-id="element-103" data-mp="14dl2ddcx869i">
          We want you to have the opportunity to review the material and decide whether it fits your professional workflow.
          If you're not satisfied, you may request a refund within seven days of purchase, subject to the applicable refund
          terms.
        </p>
        
      </div>
    </div>;
}